import $ from 'lib/jquery'
import { PageBase } from 'frontend/common-imports'
import clickToPlayWrap from 'lib/click-to-play-wrap'
import Glide, { Controls, Autoplay, Swipe, Lazy, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'

export default class LocationPage extends PageBase {
  static renderSlider () {
    new Glide('.images_slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          autoplay: 6000,
          hoverstor: true,
        },
      ),
    ).mount({ Swipe, Controls, Autoplay, Lazy })
  }

  // MAP dirty variant
  static renderMap () {
    const { markerIcon } = this.dataset
    const locationLatitude = parseFloat(this.dataset.locationLatitude)
    const locationLongitude = parseFloat(this.dataset.locationLongitude)

    var latitude = locationLatitude
    var longitude = locationLongitude
    var mapElement = $('.location_page .map')[0]
    if (latitude && longitude && mapElement) {
      var mapOptions = {
        zoom: 16,
        scrollwheel: false,
        center: { lat: latitude, lng: longitude },
        styles: [
          {
            featureType: 'road.highway',
            elementType: 'labels',
            stylers: [
              { hue: '#ffffff' },
              { saturation: -100 },
              { lightness: 100 },
              { visibility: 'off' },
            ],
          },
          {
            featureType: 'landscape.natural',
            elementType: 'all',
            stylers: [
              { hue: '#ffffff' },
              { saturation: -100 },
              { lightness: 100 },
              { visibility: 'on' },
            ],
          },
          {
            featureType: 'road',
            elementType: 'all',
            stylers: [
              { hue: '#ffe94f' },
              { saturation: 100 },
              { lightness: 4 },
              { visibility: 'on' },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [
              { hue: '#ffe94f' },
              { saturation: 100 },
              { lightness: 4 },
              { visibility: 'on' },
            ],
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              { hue: '#333333' },
              { saturation: -100 },
              { lightness: -74 },
              { visibility: 'off' },
            ],
          },
        ],
      }

      var map = new window.google.maps.Map(mapElement, mapOptions)

      new window.google.maps.Marker({
        position: new window.google.maps.LatLng(latitude, longitude),
        map: map,
        icon: markerIcon,
      })
    }
  }

  static handleDOMReady () {
    document.querySelectorAll('.about_location .video_container').forEach(el => clickToPlayWrap(el))
    this.dataset = document.body.dataset
    const { mapApiKey } = this.dataset

    if (typeof window.google !== 'undefined' && typeof window.google.maps !== 'undefined') {
      this.renderMap()
    } else {
      $.getScript(
        `https://maps.google.com/maps/api/js?key=${mapApiKey}&language=en&region=US`,
        function () {
          this.renderMap()
        }.bind(this),
      )
    }
  }

  static handleStylesApplied () {
    this.renderSlider()
  }
}

LocationPage.init()
